/**
 * ADA helpers — keep this file small.
 * Do not spray tabindex, aria-label, role="button", or role="heading".
 * External new-tab links: add rel only; announce new windows in Liquid.
 */

function externalLinkRel() {
  var currentHost = window.location.hostname;
  document.querySelectorAll('a[href]').forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.hostname && url.hostname !== currentHost) {
        if (!link.getAttribute('rel') || link.getAttribute('rel').indexOf('noopener') === -1) {
          var rel = (link.getAttribute('rel') || '')
            .split(/\s+/)
            .filter(Boolean);
          if (rel.indexOf('noopener') === -1) rel.push('noopener');
          if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
          link.setAttribute('rel', rel.join(' '));
        }
      }
    } catch (e) {
      /* invalid href */
    }
  });
}

function productRwdVideoNames() {
  if (!document.body.classList.contains('template-product')) return;
  Array.prototype.forEach.call(document.getElementsByClassName('rwd-video'), function (rwdVideo) {
    var heading = rwdVideo.querySelector('h2');
    var anchor = rwdVideo.querySelector('a');
    var img = rwdVideo.querySelector('img');
    if (!heading) return;
    var name = (heading.textContent || '').trim();
    if (!name) return;
    if (anchor && !(anchor.textContent || '').trim() && !anchor.getAttribute('aria-label')) {
      anchor.setAttribute('aria-label', name);
    }
    if (img && !img.getAttribute('alt')) {
      img.setAttribute('alt', name);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    externalLinkRel();
    productRwdVideoNames();
  });
} else {
  externalLinkRel();
  productRwdVideoNames();
}
